import React, { useState } from "react";
import { Topbar, Alert, FloatLabelInputPassword } from "@components";
import { useNavigate } from "react-router-dom";
import {
  ChangePinContainer,
  ChangePinTitle,
  Button,
  SubTitle,
  Form,
} from "./ChangePin.style";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { openAlert } from "@redux/app/appSlice";
import { useRef } from "react";
import { useEffect } from "react";

const ChangePin = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [dynamicHeight, setDynamicHeight] = useState(0);
  const ref = useRef();

  useEffect(() => {
    setDynamicHeight(ref?.current?.offsetHeight);
  }, [ref]);
  console.log(ref?.current?.offsetHeight);

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.PROFILE}`);
  };

  const onFinish = (data) => {
    if (!loading) {
      if (data.new_pin !== data.confirm_pin) {
        showAlert({
          message: t("profile.newAndConfirmPinDoNotMatch"),
          isError: true,
        });
        return;
      }
      setLoading(true);
      api
        .updatePin(data)
        .then(() => {
          setLoading(false);
          showAlert({
            message: t("common.updateSuccessMessage"),
            successCallback: goBack,
          });
        })
        .catch((errorMsg) => {
          setLoading(false);
          showAlert({
            message: errorMsg,
            isError: true,
          });
        });
    }
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  return (
    <>
      <Topbar title={t("profile.changePin")} goBack={goBack} />
      <ChangePinContainer >
        <ChangePinTitle ref={ref}>{t("profile.changePinHeading")}</ChangePinTitle>
        <SubTitle> {t("profile.changePinSubHeading")} </SubTitle>
        <Form
          layout="vertical"
          dynamicHeight={dynamicHeight}
          onFinish={onFinish}
        >
          <Form.Item
            name="old_pin"
            rules={[
              {
                required: true,
                message: "",
              },
              {
                pattern: /^[0-9]{6}$/,
                message: t("profile.oldPinValidateMessage"),
              },
            ]}
          >
            <FloatLabelInputPassword
              label={t("profile.enterOldPin")}
              placeholder={t("profile.enterOldPin")}
            />
          </Form.Item>
          <Form.Item
            name="new_pin"
            rules={[
              {
                required: true,
                message: "",
              },
              {
                pattern: /^[0-9]{6}$/,
                message: t("profile.newPinValidateMessage"),
              },
            ]}
          >
            <FloatLabelInputPassword
              placeholder={t("profile.enterNewPin")}
              label={t("profile.enterNewPin")}
            />
          </Form.Item>
          <Form.Item
            name="confirm_pin"
            rules={[
              {
                required: true,
                message: "",
              },
              {
                pattern: /^[0-9]{6}$/,
                message: t("profile.confirmPinValidateMessage"),
              },
            ]}
          >
            <FloatLabelInputPassword
              placeholder={t("profile.enterConfirmNewPin")}
              label={t("profile.enterConfirmNewPin")}
            />

          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              loading={loading}
            >
              {t("common.save")}
            </Button>
          </Form.Item>
        </Form>
      </ChangePinContainer>
      <Alert />
    </>
  );
};

export default ChangePin;
